import { BaseModule } from "../../../composition/module/BaseModule";
import { LoginModuleFlowExecutor } from "./LoginModuleFlowExecutor";
import { EmailAuthPopupScene } from "./emailauthpopup/EmailAuthPopupScene";
import { CreateWalletPopupController } from "./emailauthpopup/controller/CreateWalletPopupController";
import { EmailVerificationPopupScene } from "./emailverificationpopup/EmailVerificationPopupScene";
import { CreateWalletVerificationPopupController } from "./emailverificationpopup/controller/CreateWalletVerificationPopupController";
import { MainLoginPopupScene } from "./mainloginpopup/MainLoginPopupScene";
import { SignInSuccessfulPopupScene } from "./signinsuccessfulpopup/SignInSuccessfulPopupScene";
import { ValidationFailedPopupScene } from "./validationfailedpopup/ValidationFailedPopupScene";
import { ParamDescription } from "../../../composition/module/ParamDescription";
import { LoginResourcePackage } from "./resources/LoginResourcePackage";
import { CreatePasskeyWalletPopupController } from "./passkeyLoginPopup/controller/CreatePasskeyWalletPopupController";
import { PasskeyAuthPopupScene } from "./passkeyLoginPopup/PasskeyLoginScenet";

export class LoginModule extends BaseModule<void> {
    private loginResources: LoginResourcePackage;

    public override async build(): Promise<void> {
        this.internalContainer.register(LoginModuleFlowExecutor, LoginModuleFlowExecutor);

        this.internalContainer.register(MainLoginPopupScene, MainLoginPopupScene);

        this.internalContainer.register("IEmailAuthPopupController", CreateWalletPopupController);
        this.internalContainer.register(EmailAuthPopupScene, EmailAuthPopupScene);

        this.internalContainer.register("IPasskeyWalletPopupController", CreatePasskeyWalletPopupController);
        this.internalContainer.register(PasskeyAuthPopupScene, PasskeyAuthPopupScene);

        this.internalContainer.register("IEmailVerificationPopupController", CreateWalletVerificationPopupController);
        this.internalContainer.register("EmailVerificationPopupSceneFactory", {
            useValue: async (email: string) => {
                return await this.resolveWithParams(this.internalContainer, EmailVerificationPopupScene, new ParamDescription(String, email));
            },
        });

        this.loginResources = new LoginResourcePackage();
        await this.loginResources.load();
        this.internalContainer.registerInstance(LoginResourcePackage, this.loginResources);

        this.internalContainer.register(ValidationFailedPopupScene, ValidationFailedPopupScene);
        this.internalContainer.register(SignInSuccessfulPopupScene, SignInSuccessfulPopupScene);

        await super.build();
    }

    public async start(): Promise<void> {
        const executor = await this.internalContainer.resolve(LoginModuleFlowExecutor);
        await executor.execute(this);
        this.dispose();
    }

    public override dispose(): void {
        this.loginResources.destroy();
        super.dispose();
    }
}
